module.exports = {
	name: 'Introduction',
	exampleProps: {
		imageUrl: 'https://content-randomizer.netlify.app/images/templates/explorer/6.jpg',
		text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum"
	},
	template: [
		{
			name: 'Left Page',
			type: 'page',
			props: {
				width: { '?': { var: '$theme.pageWidth' } },
				height: { '?': { var: '$theme.pageHeight' } },
				classNames: ['page-introduction', 'page-right']
			},
			children: [
				{
					name: 'Background image',
					type: 'image',
					props: {
						width: '100%',
						height: '100%',
						position: 'absolute',
						objectFit: 'cover',
						src: { '?': { var: '$props.imageUrl' } }
					}
				}
			]
		},
		{
			name: 'Right Page',
			type: 'page',
			props: {
				width: { '?': { var: '$theme.pageWidth' } },
				height: { '?': { var: '$theme.pageHeight' } },
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				padding: { '?': { var: '$theme.pagePadding' } }
			},
			children: [
				{
					name: 'Introduction page content',
					type: 'container',
					props: {
						display: 'flex',
						padding: '60px'
					},
					children: [
						{
							type: 'container',
							props: {
								display: 'flex',
								flexDirection: 'column',
								justifyContent: 'center'
							},
							children: [
								{
									name: 'Header',
									type: 'text',
									props: {
										fontSize: '50px',
										fontFamily: 'ACaslonPro-bold',
										textAlign: 'center',
										margin: '0',
										value: 'Introduction'
									}
								},
								{
									name: 'Text',
									type: 'text',
									props: {
										value: { '?': { var: '$props.text' } },
										marginTop: '80px',
										fontFamily: 'Poppins',
										textAlign: 'center',
										fontSize: '14px'
									}
								}
							]
						}
					]
				}
			]
		}
	]
};
